export const filterTree = (
  root: Array<any>, 
  leafs: Array<any>, 
  expanded: boolean, 
  selectable: boolean, 
  styleClass = ''
) => {
  return root.filter((node) => {
    let temp;

    // Convert node.data to an array if it's not already one
    const nodeIds = Array.isArray(node.data) ? node.data.map((id: any) => id.toString()) : [node.data.toString()];

    // Check if any of the node's IDs exist in the leafs list
    if (nodeIds.some((id: any) => leafs.includes(id)) && node.leaf) {
      node.expanded = expanded;
      node.selectable = selectable;
      node.styleClass = styleClass;
      return true;
    }

    // Recursively filter children
    temp = filterTree(node.children || [], leafs, expanded, selectable, styleClass);

    if (temp.length) {
      node.children = temp;
      node.expanded = expanded;
      node.selectable = selectable;
      node.styleClass = styleClass;
      return true;
    }

    return false;
  });
};


export const filterAccountTreeByPartnerType = (root: Array<any>, leafs: Array<any>, expanded: boolean, selectable: boolean, styleClass = '') => {
  return root.filter((node) => {
      var temp;
      if (leafs.includes(node.partnerType.toString()) && node.leaf) {
        node.expanded = expanded;
        node.selectable = selectable;
        node.styleClass = styleClass;
          return true;
      }
      temp = filterAccountTreeByPartnerType(node.children || [], leafs, expanded, selectable);
      if (temp.length) {
          node.children = temp;
          node.expanded = expanded;
          node.selectable = selectable;
          node.styleClass = styleClass;
          return true;
      }
      return false;
  });
}

export const filterAccountTreeNotByPartnerType = (root: Array<any>, leafs: Array<any>, expanded: boolean, selectable: boolean, styleClass = '') => {
  return root.filter((node) => {
      var temp;
      if (!leafs.includes(node.partnerType.toString()) && node.leaf) {
        node.expanded = expanded;
        node.selectable = selectable;
        node.styleClass = styleClass;
          return true;
      }
      temp = filterAccountTreeNotByPartnerType(node.children || [], leafs, expanded, selectable);
      if (temp.length) {
          node.children = temp;
          node.expanded = expanded;
          node.selectable = selectable;
          node.styleClass = styleClass;
          return true;
      }
      return false;
  });
}
